import axiosInstance from "auth/FetchInterceptor";
import { ADD_OPTION } from "constants/ApiConstant";

const AddOptionService = {};

AddOptionService.getAllAddOptions = function (data) {
  return axiosInstance.get(`${ADD_OPTION}/${data.storeId}`, null);
};
AddOptionService.upsertAddOption = function (data) {
  return axiosInstance.post(ADD_OPTION, data);
};
AddOptionService.deleteAddOption = function (id) {
  return axiosInstance.delete(`${ADD_OPTION}/${id}`, null);
};

export default AddOptionService;
